import { render } from "./ValidationResult.vue?vue&type=template&id=a1979aae"
import script from "./ValidationResult.vue?vue&type=script&lang=js"
export * from "./ValidationResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__